import React, { createContext, useContext, useState } from 'react';

// The saved session the app is running on while the server can't be reached (offline gig mode),
// or null when online. Set by ProtectedRoute; MusicianLayout shows a banner while it's set.
const OfflineContext = createContext({ offlineSession: null, setOfflineSession: () => {} });

export function OfflineProvider({ children }) {
  const [offlineSession, setOfflineSession] = useState(null);
  return (
    <OfflineContext.Provider value={{ offlineSession, setOfflineSession }}>
      {children}
    </OfflineContext.Provider>
  );
}

export const useOfflineSession = () => useContext(OfflineContext);
